import NotificationService from '@/api/services/notification.service'
import { INotificationDto } from '@/models/dto/INotification.dto'
import store from '@/store/index'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({ dynamic: true, store, name: 'notifications' })
class Notifications extends VuexModule {
    //STORE
    notifications: INotificationDto[] = []
    notificationModalMode: 'create' | 'edit' = 'create'
    notificationsOptions = [
        { text: 'Alertas', value: 'alarm' },
        { text: 'Exceso de velocidad', value: 'deviceOverspeed' },
        { text: 'Entrada a Geocerca', value: 'geofenceEnter' },
        { text: 'Salida de Geocerca', value: 'geofenceExit' },
    ]
    notificationDataModal = {
        name: '',
        selected: 'alarm',
        devicesId: [],
        emailItems: ['', ''],
        id: 0,
    }

    //MUTATIONS
    @Mutation
    setModalData(data: any) {
        this.notificationDataModal = data
    }

    @Mutation
    setModalMode(mode: 'create' | 'edit') {
        this.notificationModalMode = mode
    }

    @Mutation
    setNotifications(notifications: any[]): void {
        this.notifications = notifications
    }

    @Mutation
    addNotifications(notification: any): void {
        this.notifications.push(notification)
    }

    @Mutation
    replaceNotification(notification: INotificationDto): void {
        this.notifications = this.notifications.map((item) => {
            return item.id === notification.id ? notification : item
        })
    }

    @Action({ commit: 'setNotifications' })
    async getAllNotifications() {
        const data = (await NotificationService.getAllNotifications()).data
        console.log(data)
        return data
    }
}

export default getModule(Notifications)
